var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShootingStar = function SvgShootingStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.366 1.112a.75.75 0 0 1 1.06 1.06l-4.395 4.396a.75.75 0 0 1-1.06-1.06zM16.66 2.696a.75.75 0 0 0-1.06-1.06l-1.5 1.5a.75.75 0 1 0 1.06 1.06zm-4.825.759a.75.75 0 0 0-1.345 0L8.064 8.368l-5.422.788a.75.75 0 0 0-.415 1.28L6.15 14.26l-.926 5.4a.75.75 0 0 0 1.088.79l4.85-2.549 4.85 2.55a.75.75 0 0 0 1.088-.791l-.927-5.4 3.924-3.825a.75.75 0 0 0-.416-1.279l-5.422-.788zm-2.6 5.93 1.928-3.904 1.926 3.905a.75.75 0 0 0 .565.41l4.309.626-3.118 3.039a.75.75 0 0 0-.216.664l.736 4.29-3.853-2.025a.75.75 0 0 0-.698 0l-3.854 2.026.736-4.291a.75.75 0 0 0-.216-.664l-3.117-3.04 4.308-.625a.75.75 0 0 0 .565-.41m12.417-4.257a.75.75 0 0 1 0 1.06l-1.5 1.5a.75.75 0 1 1-1.06-1.06l1.5-1.5a.75.75 0 0 1 1.06 0",
    clipRule: "evenodd"
  })));
};
export default SvgShootingStar;